import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { SeoService } from '../services/seo.service';

export function provideSEO(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => inject(SeoService).setSeoData()),
    provideAppInitializer(() =>
      inject(SeoService).setCanonicalUrlOnNavigationEnd(),
    ),
  ]);
}
